import { render } from "./NormeAdministrative.vue?vue&type=template&id=08bcc325&scoped=true&ts=true"
import script from "./NormeAdministrative.vue?vue&type=script&lang=ts"
export * from "./NormeAdministrative.vue?vue&type=script&lang=ts"

import "./NormeAdministrative.vue?vue&type=style&index=0&id=08bcc325&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bcc325"]])

export default __exports__